import React, { FC } from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import Layout from '../../components/Dashboard/newLayout'
import AdminDNC from './DNC'
import { Settings as SettingsStore } from '../../stores/settings'
import './styles.scss'

interface Props extends RouteComponentProps {
  setIsAuthenticated: (isAuthenticated: boolean) => void
  settings?: SettingsStore
}

const DoNotEngage: FC<Props> = ({ setIsAuthenticated, history, location, settings, match }) => {
  return (
    <Layout title="Do Not Engage" setIsAuthenticated={setIsAuthenticated}>
      <div className="main-container">
        <div className="dns-body">
          <AdminDNC {...{ history, location, settings, match }} />
        </div>
      </div>
    </Layout>
  )
}

export default inject('settings')(withRouter(observer(DoNotEngage)))
